import * as React from 'react';
import clsx from 'clsx';
import { useEchoStatsQuery } from '@/hooks/useEchoStatsQuery';
import { formatCompactNumber } from '@/utils/formatters';
import rateIcon from '@/assets/images/svg/rate_icon.svg';
import starFilledIcon from '@/assets/images/svg/star.svg';

interface ChatStatsBadgeProps {
  echoId: string;
  className?: string;
  variant?: 'default' | 'header';
}

export const ChatStatsBadge: React.FC<ChatStatsBadgeProps> = ({
  echoId,
  className,
  variant = 'default',
}) => {
  const { data } = useEchoStatsQuery(echoId);

  const totalLikes = data?.total_super_likes ?? 0;
  const formattedLikes = formatCompactNumber(totalLikes);
  const iconSrc = totalLikes > 0 ? starFilledIcon : rateIcon;

  const isHeader = variant === 'header';

  return (
    <div
      className={clsx(
        'flex items-center justify-center',
        'rounded-20',
        'transition-all duration-300',
        isHeader
          ? 'size-auto gap-1 bg-accent-620 px-[10px] py-[5px]'
          : 'h-badge w-badge gap-2 bg-brand-750/60',
        className
      )}
      title='Total Likes'
    >
      <span
        className={clsx(
          'font-sans tracking-normal text-white',
          isHeader ? 'text-[12px] font-medium leading-105' : 'text-stats font-bold'
        )}
      >
        {formattedLikes}
      </span>
      <img
        src={iconSrc}
        alt='Likes'
        className={clsx('shrink-0 object-contain', isHeader ? 'size-[11px]' : 'mb-0.5 size-4')}
      />
    </div>
  );
};
